export const DISCORD_INVITE_URL = 'https://dsc.gg/redlegacy';
